// Generated by purs version 0.15.0
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_ItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
import * as Restaumatic_Menu_V2_Types_Taxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Standard = /* #__PURE__ */ (function () {
    function Standard() {

    };
    Standard.value = new Standard();
    return Standard;
})();
var InformationOnly = /* #__PURE__ */ (function () {
    function InformationOnly() {

    };
    InformationOnly.value = new InformationOnly();
    return InformationOnly;
})();
var RequiresCoupon = /* #__PURE__ */ (function () {
    function RequiresCoupon() {

    };
    RequiresCoupon.value = new RequiresCoupon();
    return RequiresCoupon;
})();
var CartTarget = /* #__PURE__ */ (function () {
    function CartTarget() {

    };
    CartTarget.value = new CartTarget();
    return CartTarget;
})();
var ProductTarget = /* #__PURE__ */ (function () {
    function ProductTarget() {

    };
    ProductTarget.value = new ProductTarget();
    return ProductTarget;
})();
var PromotionIdFilter = /* #__PURE__ */ (function () {
    function PromotionIdFilter(value0) {
        this.value0 = value0;
    };
    PromotionIdFilter.create = function (value0) {
        return new PromotionIdFilter(value0);
    };
    return PromotionIdFilter;
})();
var ItemIdFilter = /* #__PURE__ */ (function () {
    function ItemIdFilter(value0) {
        this.value0 = value0;
    };
    ItemIdFilter.create = function (value0) {
        return new ItemIdFilter(value0);
    };
    return ItemIdFilter;
})();
var ProductCategoryIdFilter = /* #__PURE__ */ (function () {
    function ProductCategoryIdFilter(value0) {
        this.value0 = value0;
    };
    ProductCategoryIdFilter.create = function (value0) {
        return new ProductCategoryIdFilter(value0);
    };
    return ProductCategoryIdFilter;
})();
var ParameterValueFilter = /* #__PURE__ */ (function () {
    function ParameterValueFilter(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ParameterValueFilter.create = function (value0) {
        return function (value1) {
            return new ParameterValueFilter(value0, value1);
        };
    };
    return ParameterValueFilter;
})();
var AnyComboFilter = /* #__PURE__ */ (function () {
    function AnyComboFilter() {

    };
    AnyComboFilter.value = new AnyComboFilter();
    return AnyComboFilter;
})();
var ProductPromotionRequirements = function (x) {
    return x;
};
var FreeProduct = function (x) {
    return x;
};
var Freeby = /* #__PURE__ */ (function () {
    function Freeby(value0) {
        this.value0 = value0;
    };
    Freeby.create = function (value0) {
        return new Freeby(value0);
    };
    return Freeby;
})();
var PercentageDiscount = /* #__PURE__ */ (function () {
    function PercentageDiscount(value0) {
        this.value0 = value0;
    };
    PercentageDiscount.create = function (value0) {
        return new PercentageDiscount(value0);
    };
    return PercentageDiscount;
})();
var PriceDiscount = /* #__PURE__ */ (function () {
    function PriceDiscount(value0) {
        this.value0 = value0;
    };
    PriceDiscount.create = function (value0) {
        return new PriceDiscount(value0);
    };
    return PriceDiscount;
})();
var CouponValue = /* #__PURE__ */ (function () {
    function CouponValue() {

    };
    CouponValue.value = new CouponValue();
    return CouponValue;
})();
var TextInformation = /* #__PURE__ */ (function () {
    function TextInformation() {

    };
    TextInformation.value = new TextInformation();
    return TextInformation;
})();
var CartValue = /* #__PURE__ */ (function () {
    function CartValue(value0) {
        this.value0 = value0;
    };
    CartValue.create = function (value0) {
        return new CartValue(value0);
    };
    return CartValue;
})();
var FirstOrder = /* #__PURE__ */ (function () {
    function FirstOrder() {

    };
    FirstOrder.value = new FirstOrder();
    return FirstOrder;
})();
var Loyalty = /* #__PURE__ */ (function () {
    function Loyalty() {

    };
    Loyalty.value = new Loyalty();
    return Loyalty;
})();
var HasCoupon = /* #__PURE__ */ (function () {
    function HasCoupon() {

    };
    HasCoupon.value = new HasCoupon();
    return HasCoupon;
})();
var Always = /* #__PURE__ */ (function () {
    function Always() {

    };
    Always.value = new Always();
    return Always;
})();
var Never = /* #__PURE__ */ (function () {
    function Never() {

    };
    Never.value = new Never();
    return Never;
})();
var CartPromotion = /* #__PURE__ */ (function () {
    function CartPromotion(value0) {
        this.value0 = value0;
    };
    CartPromotion.create = function (value0) {
        return new CartPromotion(value0);
    };
    return CartPromotion;
})();
var ProductPromotion = /* #__PURE__ */ (function () {
    function ProductPromotion(value0) {
        this.value0 = value0;
    };
    ProductPromotion.create = function (value0) {
        return new ProductPromotion(value0);
    };
    return ProductPromotion;
})();
var newtypeProductPromotionRe = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeFreeProduct_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldProductPromotionR = function (dictHasField) {
    return dictHasField;
};
var hasFieldFreeProduct = function (dictHasField) {
    return dictHasField;
};
var eqPromotionType = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Standard && y instanceof Standard) {
                return true;
            };
            if (x instanceof InformationOnly && y instanceof InformationOnly) {
                return true;
            };
            if (x instanceof RequiresCoupon && y instanceof RequiresCoupon) {
                return true;
            };
            return false;
        };
    }
};
var ordPromotionType = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Standard && y instanceof Standard) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Standard) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Standard) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof InformationOnly && y instanceof InformationOnly) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof InformationOnly) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof InformationOnly) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof RequiresCoupon && y instanceof RequiresCoupon) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 46, column 1 - line 46, column 34): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqPromotionType;
    }
};
var eqPromotionTarget = {
    eq: function (x) {
        return function (y) {
            if (x instanceof CartTarget && y instanceof CartTarget) {
                return true;
            };
            if (x instanceof ProductTarget && y instanceof ProductTarget) {
                return true;
            };
            return false;
        };
    }
};
var ordPromotionTarget = {
    compare: function (x) {
        return function (y) {
            if (x instanceof CartTarget && y instanceof CartTarget) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof CartTarget) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof CartTarget) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ProductTarget && y instanceof ProductTarget) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 79, column 1 - line 79, column 36): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqPromotionTarget;
    }
};
var eqPromotionFilter = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Promotions_Types_Id.eqPromotionId))(x.value0)(y.value0);
        };
    }
};
var eqProductSingleFilter = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ItemIdFilter && y instanceof ItemIdFilter) {
                return Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_ItemId.eqItemId))(x.value0)(y.value0);
            };
            if (x instanceof ProductCategoryIdFilter && y instanceof ProductCategoryIdFilter) {
                return Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.value0)(y.value0);
            };
            if (x instanceof ParameterValueFilter && y instanceof ParameterValueFilter) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(x.value0)(y.value0) && Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.value1)(y.value1);
            };
            if (x instanceof AnyComboFilter && y instanceof AnyComboFilter) {
                return true;
            };
            return false;
        };
    }
};
var ordProductSingleFilter = {
    compare: function (x) {
        return function (y) {
            if (x instanceof ItemIdFilter && y instanceof ItemIdFilter) {
                return Data_Ord.compare(Data_Ord.ordArray(Restaumatic_Menu_V2_Types_ItemId.ordItemId))(x.value0)(y.value0);
            };
            if (x instanceof ItemIdFilter) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ItemIdFilter) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ProductCategoryIdFilter && y instanceof ProductCategoryIdFilter) {
                return Data_Ord.compare(Data_Ord.ordArray(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(x.value0)(y.value0);
            };
            if (x instanceof ProductCategoryIdFilter) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ProductCategoryIdFilter) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ParameterValueFilter && y instanceof ParameterValueFilter) {
                var v = Data_Ord.compare(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(x.value0)(y.value0);
                if (v instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                return Data_Ord.compare(Data_Ord.ordArray(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(x.value1)(y.value1);
            };
            if (x instanceof ParameterValueFilter) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ParameterValueFilter) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof AnyComboFilter && y instanceof AnyComboFilter) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 167, column 1 - line 167, column 40): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqProductSingleFilter;
    }
};
var eqProductPromotionRequire = {
    eq: function (x) {
        return function (y) {
            return x.numRequiredItems === y.numRequiredItems && Data_Eq.eq(Data_Eq.eqArray(eqProductSingleFilter))(x.productFilter)(y.productFilter) && x.repeatable === y.repeatable;
        };
    }
};
var eqFreeProduct = {
    eq: function (x) {
        return function (y) {
            return x.productName === y.productName && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.productValue)(y.productValue) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.vatRate)(y.vatRate);
        };
    }
};
var eqPromotionPrize = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Freeby && y instanceof Freeby) {
                return Data_Eq.eq(Data_Eq.eqArray(eqFreeProduct))(x.value0)(y.value0);
            };
            if (x instanceof PercentageDiscount && y instanceof PercentageDiscount) {
                return x.value0 === y.value0;
            };
            if (x instanceof PriceDiscount && y instanceof PriceDiscount) {
                return Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.value0)(y.value0);
            };
            if (x instanceof CouponValue && y instanceof CouponValue) {
                return true;
            };
            if (x instanceof TextInformation && y instanceof TextInformation) {
                return true;
            };
            return false;
        };
    }
};
var eqCartPromotionRequiremen = {
    eq: function (x) {
        return function (y) {
            if (x instanceof CartValue && y instanceof CartValue) {
                return Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.value0.minCartValue)(y.value0.minCartValue);
            };
            if (x instanceof FirstOrder && y instanceof FirstOrder) {
                return true;
            };
            if (x instanceof Loyalty && y instanceof Loyalty) {
                return true;
            };
            if (x instanceof HasCoupon && y instanceof HasCoupon) {
                return true;
            };
            if (x instanceof Always && y instanceof Always) {
                return true;
            };
            if (x instanceof Never && y instanceof Never) {
                return true;
            };
            return false;
        };
    }
};
var eqPromotionConditions = {
    eq: function (x) {
        return function (y) {
            if (x instanceof CartPromotion && y instanceof CartPromotion) {
                return Data_Eq.eq(eqCartPromotionRequiremen)(x.value0)(y.value0);
            };
            if (x instanceof ProductPromotion && y instanceof ProductPromotion) {
                return Data_Eq.eq(eqProductPromotionRequire)(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var genericPromotionType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Standard.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return InformationOnly.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return RequiresCoupon.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 32, column 1 - line 32, column 81): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Standard) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof InformationOnly) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof RequiresCoupon) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 32, column 1 - line 32, column 81): " + [ x.constructor.name ]);
    }
};
var showPromotionType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionType)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    }))))
};
var unscrambleDecodePromotionType = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericPromotionType)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    }))))(Unscramble_Enum.defaultEnumOptions)
};
var boundedPromotionType = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericPromotionType)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments)))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericPromotionType)(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    Ord0: function () {
        return ordPromotionType;
    }
};
var enumPromotionType = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericPromotionType)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericPromotionType)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))),
    Ord0: function () {
        return ordPromotionType;
    }
};
var boundedEnumPromotionType = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericPromotionType)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments)))),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericPromotionType)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments)))),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericPromotionType)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments)))),
    Bounded0: function () {
        return boundedPromotionType;
    },
    Enum1: function () {
        return enumPromotionType;
    }
};
var genericPromotionTarget = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return CartTarget.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return ProductTarget.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 65, column 1 - line 65, column 85): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof CartTarget) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ProductTarget) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 65, column 1 - line 65, column 85): " + [ x.constructor.name ]);
    }
};
var showPromotionTarget = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionTarget)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "CartTarget";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ProductTarget";
        }
    })))
};
var unscrambleDecodePromotionTarget = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericPromotionTarget)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "CartTarget";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ProductTarget";
        }
    })))(Unscramble_Enum.defaultEnumOptions)
};
var boundedPromotionTarget = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericPromotionTarget)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericPromotionTarget)(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    Ord0: function () {
        return ordPromotionTarget;
    }
};
var enumPromotionTarget = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericPromotionTarget)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericPromotionTarget)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    Ord0: function () {
        return ordPromotionTarget;
    }
};
var boundedEnumPromotionTarge = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericPromotionTarget)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericPromotionTarget)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericPromotionTarget)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))),
    Bounded0: function () {
        return boundedPromotionTarget;
    },
    Enum1: function () {
        return enumPromotionTarget;
    }
};
var genericPromotionPrize = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Freeby(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new PercentageDiscount(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new PriceDiscount(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return CouponValue.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return TextInformation.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 97, column 1 - line 97, column 83): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Freeby) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof PercentageDiscount) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof PriceDiscount) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof CouponValue) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof TextInformation) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 97, column 1 - line 97, column 83): " + [ x.constructor.name ]);
    }
};
var genericPromotionFilter = {
    to: function (x) {
        return new PromotionIdFilter(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var showPromotionFilter = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionFilter)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Promotions_Types_Id.showPromotionId)))({
        reflectSymbol: function () {
            return "PromotionIdFilter";
        }
    }))
};
var udecodePromotionFilter = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecodeTagged(genericPromotionFilter)(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PromotionIdFilter";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Promotions_Types_Id.decodePromotionId))))(Unscramble_Generic.defaultOptions)
};
var genericPromotionConditions = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new CartPromotion(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new ProductPromotion(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 144, column 1 - line 144, column 93): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof CartPromotion) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof ProductPromotion) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 144, column 1 - line 144, column 93): " + [ x.constructor.name ]);
    }
};
var genericProductSingleFilter = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ItemIdFilter(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new ProductCategoryIdFilter(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new ParameterValueFilter(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return AnyComboFilter.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 162, column 1 - line 162, column 93): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ItemIdFilter) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof ProductCategoryIdFilter) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ParameterValueFilter) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))));
        };
        if (x instanceof AnyComboFilter) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 162, column 1 - line 162, column 93): " + [ x.constructor.name ]);
    }
};
var showProductSingleFilter = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductSingleFilter)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_ItemId.showItemId)))({
        reflectSymbol: function () {
            return "ItemIdFilter";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))({
        reflectSymbol: function () {
            return "ProductCategoryIdFilter";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))))({
        reflectSymbol: function () {
            return "ParameterValueFilter";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AnyComboFilter";
        }
    })))))
};
var unscrambleDecodeProductSingleFilter = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductSingleFilter)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ItemIdFilter";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_ItemId.unscrambleDecodeItemId))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ProductCategoryIdFilter";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgs1(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsProd(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)))))({
        reflectSymbol: function () {
            return "ParameterValueFilter";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "AnyComboFilter";
        }
    }))))))(Unscramble_Generic.defaultOptions)
};
var genericProductPromotionRequirements = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductPromotionRequirements = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductPromotionRequirements)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "numRequiredItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productFilter";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "repeatable";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showBoolean))(/* #__PURE__ */ Data_Show.showArray(showProductSingleFilter)))(Data_Show.showInt))))({
        reflectSymbol: function () {
            return "ProductPromotionRequirements";
        }
    }))
};
var unscrambleDecodeProductPromotionRequirements = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductPromotionRequirements)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "numRequiredItems";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "productFilter";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeProductSingleFilter))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "repeatable";
        }
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericFreeProduct = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showFreeProduct = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFreeProduct)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productValue";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Money_Rounded.showMoney))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "FreeProduct";
        }
    }))
};
var showPromotionPrize = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionPrize)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(showFreeProduct)))({
        reflectSymbol: function () {
            return "Freeby";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "PercentageDiscount";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Money_Rounded.showMoney))({
        reflectSymbol: function () {
            return "PriceDiscount";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "CouponValue";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "TextInformation";
        }
    }))))))
};
var unscrambleDecodeFreeProduct = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericFreeProduct)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "productName";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "productValue";
        }
    })(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodePromotionPrize = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionPrize)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Freeby";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeFreeProduct))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PercentageDiscount";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeInt1)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PriceDiscount";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Data_Money_Rounded.udecodeMoney)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "CouponValue";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "TextInformation";
        }
    })))))))(Unscramble_Generic.defaultOptions)
};
var genericCartPromotionRequirement = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new CartValue(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return FirstOrder.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Loyalty.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return HasCoupon.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return Always.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
            return Never.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 245, column 1 - line 245, column 103): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof CartValue) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof FirstOrder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Loyalty) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof HasCoupon) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Always) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof Never) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 245, column 1 - line 245, column 103): " + [ x.constructor.name ]);
    }
};
var ordCartPromotionRequirement = {
    compare: function (v) {
        return function (v1) {
            if (v instanceof CartValue && v1 instanceof CartValue) {
                return Data_Ord.compare(Data_Money_Rounded.ordMoney)(v.value0.minCartValue)(v1.value0.minCartValue);
            };
            if (v1 instanceof CartValue) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof CartValue) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord_Generic.genericCompare(genericCartPromotionRequirement)(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdArgument(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
                reflectSymbol: function () {
                    return "minCartValue";
                }
            })(Data_Money_Rounded.ordMoney)))))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments)))))))(v)(v1);
        };
    },
    Eq0: function () {
        return eqCartPromotionRequiremen;
    }
};
var ordPromotionConditions = {
    compare: function (v) {
        return function (v1) {
            if (v instanceof ProductPromotion && v1 instanceof ProductPromotion) {
                return Data_Ord.compare(Data_Ord.ordArray(ordProductSingleFilter))(Data_Record.getField(hasFieldProductPromotionR(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "productFilter";
                    }
                })()))(Type_Proxy["Proxy"].value)(v.value0))(Data_Record.getField(hasFieldProductPromotionR(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "productFilter";
                    }
                })()))(Type_Proxy["Proxy"].value)(v1.value0));
            };
            if (v instanceof ProductPromotion && v1 instanceof CartPromotion) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof CartPromotion && v1 instanceof ProductPromotion) {
                return Data_Ordering.GT.value;
            };
            if (v instanceof CartPromotion && v1 instanceof CartPromotion) {
                return Data_Ord.compare(ordCartPromotionRequirement)(v.value0)(v1.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Types.Promotion (line 139, column 1 - line 143, column 60): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqPromotionConditions;
    }
};
var showCartPromotionRequirement = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCartPromotionRequirement)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "minCartValue";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))))({
        reflectSymbol: function () {
            return "CartValue";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "FirstOrder";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Loyalty";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "HasCoupon";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Always";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Never";
        }
    })))))))
};
var showPromotionConditions = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionConditions)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showCartPromotionRequirement))({
        reflectSymbol: function () {
            return "CartPromotion";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showProductPromotionRequirements))({
        reflectSymbol: function () {
            return "ProductPromotion";
        }
    })))
};
var unscrambleDecodeCartPromotionRequirement = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCartPromotionRequirement)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "CartValue";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "minCartValue";
        }
    })(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "FirstOrder";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Loyalty";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "HasCoupon";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Always";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Never";
        }
    }))))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodePromotionConditions = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionConditions)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "CartPromotion";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(unscrambleDecodeCartPromotionRequirement)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ProductPromotion";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(unscrambleDecodeProductPromotionRequirements)))))(Unscramble_Generic.defaultOptions)
};
var encodePromotionType = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericPromotionType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    }))))
};
var encodePromotionTarget = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericPromotionTarget)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "CartTarget";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ProductTarget";
        }
    })))
};
var encodePromotionFilter = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericPromotionFilter)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PromotionIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Promotions_Types_Id.encodePromotionId)))))(Foreign_Generic_Class.defaultOptions)
};
var encodeProductSingleFilter = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductSingleFilter)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ItemIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_ItemId.encodeItemId)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductCategoryIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ParameterValueFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsProduct(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AnyComboFilter";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))
};
var encodeProductPromotionRequirements = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductPromotionRequirements)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductPromotionRequirements";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "repeatable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "productFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeProductSingleFilter))))({
        reflectSymbol: function () {
            return "numRequiredItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))
};
var encodeFreeProduct = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericFreeProduct)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "FreeProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "productValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "productName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var encodePromotionPrize = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionPrize)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Freeby";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeFreeProduct)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PercentageDiscount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PriceDiscount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CouponValue";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "TextInformation";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))))))
};
var encodeCartPromotionRequirement = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCartPromotionRequirement)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CartValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "minCartValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "FirstOrder";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Loyalty";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "HasCoupon";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Always";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Never";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))))
};
var encodePromotionConditions = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionConditions)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CartPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeCartPromotionRequirement))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeProductPromotionRequirements)))))
};
var decodePromotionType = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericPromotionType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    }))))
};
var decodePromotionTarget = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericPromotionTarget)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "CartTarget";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ProductTarget";
        }
    })))
};
var decodePromotionFilter = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericPromotionFilter)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PromotionIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Promotions_Types_Id.decodePromotionId1))))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.defaultOptions)
};
var decodeProductSingleFilter = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductSingleFilter)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ItemIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_ItemId.decodeItemId))))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductCategoryIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId))))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ParameterValueFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsProduct(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))))(/* #__PURE__ */ Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AnyComboFilter";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))
};
var decodeProductPromotionRequirements = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductPromotionRequirements)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductPromotionRequirements";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "repeatable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "productFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeProductSingleFilter)))())({
        reflectSymbol: function () {
            return "numRequiredItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeFreeProduct = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericFreeProduct)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "FreeProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "productValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "productName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodePromotionPrize = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionPrize)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Freeby";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeFreeProduct))))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PercentageDiscount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PriceDiscount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CouponValue";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "TextInformation";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))))))
};
var decodeCartPromotionRequirement = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCartPromotionRequirement)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CartValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "minCartValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "FirstOrder";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Loyalty";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "HasCoupon";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Always";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Never";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))))
};
var decodePromotionConditions = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionConditions)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CartPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeCartPromotionRequirement)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeProductPromotionRequirements)))(Foreign_Generic_Class.genericCountArgsArgument)))
};
export {
    Standard,
    InformationOnly,
    RequiresCoupon,
    CartTarget,
    ProductTarget,
    Freeby,
    PercentageDiscount,
    PriceDiscount,
    CouponValue,
    TextInformation,
    PromotionIdFilter,
    CartPromotion,
    ProductPromotion,
    ItemIdFilter,
    ProductCategoryIdFilter,
    ParameterValueFilter,
    AnyComboFilter,
    ProductPromotionRequirements,
    FreeProduct,
    CartValue,
    FirstOrder,
    Loyalty,
    HasCoupon,
    Always,
    Never,
    genericPromotionType,
    eqPromotionType,
    showPromotionType,
    encodePromotionType,
    decodePromotionType,
    unscrambleDecodePromotionType,
    ordPromotionType,
    enumPromotionType,
    boundedPromotionType,
    boundedEnumPromotionType,
    genericPromotionTarget,
    eqPromotionTarget,
    showPromotionTarget,
    encodePromotionTarget,
    decodePromotionTarget,
    unscrambleDecodePromotionTarget,
    ordPromotionTarget,
    enumPromotionTarget,
    boundedPromotionTarget,
    boundedEnumPromotionTarge,
    genericPromotionPrize,
    eqPromotionPrize,
    showPromotionPrize,
    encodePromotionPrize,
    decodePromotionPrize,
    unscrambleDecodePromotionPrize,
    encodePromotionFilter,
    decodePromotionFilter,
    udecodePromotionFilter,
    genericPromotionFilter,
    eqPromotionFilter,
    showPromotionFilter,
    ordPromotionConditions,
    genericPromotionConditions,
    eqPromotionConditions,
    showPromotionConditions,
    encodePromotionConditions,
    decodePromotionConditions,
    unscrambleDecodePromotionConditions,
    genericProductSingleFilter,
    eqProductSingleFilter,
    showProductSingleFilter,
    ordProductSingleFilter,
    encodeProductSingleFilter,
    decodeProductSingleFilter,
    unscrambleDecodeProductSingleFilter,
    genericProductPromotionRequirements,
    eqProductPromotionRequire,
    showProductPromotionRequirements,
    encodeProductPromotionRequirements,
    decodeProductPromotionRequirements,
    unscrambleDecodeProductPromotionRequirements,
    hasFieldProductPromotionR,
    newtypeProductPromotionRe,
    genericFreeProduct,
    eqFreeProduct,
    showFreeProduct,
    encodeFreeProduct,
    decodeFreeProduct,
    unscrambleDecodeFreeProduct,
    hasFieldFreeProduct,
    newtypeFreeProduct_,
    ordCartPromotionRequirement,
    genericCartPromotionRequirement,
    eqCartPromotionRequiremen,
    showCartPromotionRequirement,
    encodeCartPromotionRequirement,
    decodeCartPromotionRequirement,
    unscrambleDecodeCartPromotionRequirement
};
//# sourceMappingURL=index.js.map
